import { OverlapTransitionStateContext } from "@redotech/react-animation/outlet-transition";
import { OverlapTransitionState } from "@redotech/react-animation/transition";
import { useRequiredContext } from "@redotech/react-util/context";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { DocumentTitleOverridersContext } from "@redotech/redo-merchant-app-common/title";
import { nativeRandom, randomHexString } from "@redotech/util/random";
import { memo, useContext, useLayoutEffect, useState } from "react";
import { ActiveViewContext } from "./conversations-table-filters/active-view-context";
import { viewUrlNameToDisplayName } from "./view-name-utils";

export const SupportDocumentTitleOverrider = memo(
  function SupportDocumentTitleOverrider() {
    const [, setDocumentTitleOverriders] = useContext(
      DocumentTitleOverridersContext,
    );
    const team = useRequiredContext(TeamContext);
    const activeView = useContext(ActiveViewContext);

    const [overrideHash, setOverrideHash] = useState<string>(
      randomHexString(nativeRandom, 24),
    );

    useLayoutEffect(() => {
      setOverrideHash(randomHexString(nativeRandom, 24));
    }, [activeView.name]);

    const transitionState = useContext(OverlapTransitionStateContext);

    const clearDocumentTitleOverriders = () => {
      setDocumentTitleOverriders((prev) => {
        prev?.delete(overrideHash);
        return Object.assign(new Map(prev), prev);
      });
    };

    /**
     * There's a time between when this is exiting and when it's derendered
     * (follow `transitionState`). We need to clear the overrides so that the
     * next component doesn't get the old overrides.
     */
    useLayoutEffect(() => {
      if (transitionState === OverlapTransitionState.EXIT) {
        clearDocumentTitleOverriders();
      }
      // FIXME
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [transitionState]);

    useLayoutEffect(
      function showCustomSupportDocumentTitle() {
        if (transitionState === OverlapTransitionState.EXIT) {
          return;
        }
        setDocumentTitleOverriders((prev) => {
          prev?.set(
            overrideHash,
            () =>
              `${viewUrlNameToDisplayName(activeView.name)} - ${team.name} Support`,
          );
          return Object.assign(new Map(prev), prev);
        });
        return clearDocumentTitleOverriders;
      },
      // FIXME
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [activeView.name],
    );

    return null;
  },
);
